module.exports = __webpack_public_path__ + "img/ski19.482a8842.jpg";